<template>
  <div class="selector">
    <div class="label" @click="toggleDrop">
      <span v-if="selected">{{ selected.label }}</span>
      <span class="placeholder" v-else>Choose definition</span>
      <div class="right-side-icon">
        <sprite name="iconDownDir" />
      </div>
    </div>
    <ul class="drop" v-if="dropActive">
      <li @click="select(option, $event)" v-for="option in options" :key="option.id">
        {{ option.label }}
      </li>
      <li class="clear" v-if="selected" @click.stop.prevent="clear">Clear Definition</li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'vocabDefinition',
    props: {
      value: Number,
      available: Array,
      all: Array
    },
    data () {
      const selected = (() => {
        if(this.value) {
          const definition = this.all.find(d => d.id==this.value)
          return {
            id: definition.id,
            label: definition.definition,
            enabled: false
          }
        } else {
          return null
        }
      })()
      return {
        selected,
        dropActive: false
      }
    },
    methods: {
      select (option, event) {
        this.selected = option
        this.$emit("input", option.id)
      },
      clear () {
        this.selected = null
        this.$emit("input", null)
      },
      toggleDrop () {
        this.dropActive = !this.dropActive
        if(this.dropActive) {
          this.$nextTick(() => {
            $(window).one("click", () => {
              this.dropActive = false
            })
          })
        }
      }
    },
    computed: {
      options () {
        const options = this.available.map((definition) => {
          return {
            id: definition.id,
            label: definition.definition
          }
        })
        return _.shuffle(options)
      }
    }
  }
</script>

<style lang="scss" scoped>

  @import "~globals";

  .selector {
    margin:1rem 0; background:#fff; border:1px solid $color-gray-lighter; position:relative; font-size:80%; line-height:1.3;
  }

  .label {
    padding:1rem 3rem 1rem 1rem; cursor:pointer;
  }

  .drop {
    width:calc(100% + 2px); position:absolute; top:100%; bottom:auto; left:0; background:#fff; z-index:9; margin:0 -1px 0; padding:0; list-style:none; border:1px solid $color-gray-lighter; border-top:0; box-shadow:$box-shadow;
    li {
      padding:.75rem 1rem; cursor:pointer;
      &:hover {
        background-color:$color-gray-background;
      }
    }
  }

  .right-side-icon {
    display:flex; align-items:center; justify-content:center; width:3.5rem; position:absolute; top:0; bottom:0; right:0rem; z-index:3; cursor:pointer;
/*    background:$color-gray-background; border-left:1px solid $color-gray-lighter;*/
    svg {
      width:1.5rem;
    }
  }

  .placeholder {
    opacity:.75;
  }

  .clear {
    @include transition();
    border-top:1px solid $color-gray-lighter; text-align:center; font-size:90%; color:$color-primary;
    &:hover, &:focus {
      color:$color-primary-darker;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/VisualVocab/selector.vue